const data = [
  {
    index: 0,
    title: "LWT Mobile App",
    link: "https://play.google.com/store/apps/details?id=com.lookwhostalkingApp",
    description: "Discover campaigns, engage & earn by collaborating with the top brands.",
    summary:
      "Developed on React-Native, this mobile app is a product of my current organization Look Who's Talking. It enables the influencers/creators to discover and engage in any campaign in just a few simple steps. Build your creator profile, connect multiple accounts across all major platforms like Instagram, Facebook, Twitter, Blog(Google Analytics) & Youtube and learn better about your social status & audience circle, all in one place.",
    role: "Lead Developer",
    thumbnail: "./images/LWTAppCover.png",
    stack: ["React-Native", "javascript", "Redux"],
    images: [
      "/images/LWTAppCover.png",
      "/images/LWTApp1.png",
      "/images/LWTApp2.png",
      "/images/LWTApp3.png"
    ]
  },
  {
    index: 1,
    title: "FireGram",
    link: "https://photoapp-38e4c.firebaseapp.com/",
    description:
      "Upload your memories in form of pictures on FireGram, a Photo gallery app that stores images on firebase storage.",
    summary:
      "Firebase as a backend service has always amused me, I was new to firebase and decided to create a photo gallery app since it is inspired by Instagram and images are stored on Firebase storage bucket, hence it got its name FireGram.",
    role: "Developer",
    thumbnail: "./images/FiregramImage1.png",
    stack: [
      "html",
      "css",
      "react.js",
      "firebase",
      "framer-motion"
    ],
    images: [
      "/images/FiregramImage1.png",
      "/images/FiregramImage2.jpg",
      "/images/FiregramImage3.jpg"
    ]
  },
  {
    index: 2,
    title: "Chat App",
    link: "https://chat-io-node.herokuapp.com/",
    description:
      "A fully functional chat app with all device compatibility, Implemented using WebSocket to communicate between users.",
    role: "Developer",
    summary:
      "During my college days when I was exploring new technologies, I came across node.js. I was always curious to know how messaging application works, the solution that I found was using Socket.IO which uses WebSockets to communicate between applications by creating a single TCP connection. Since my inspiration was Whatsapp, so I decided to create a messaging application with rooms serving as groups, where users can chat and share their current location. For current location detection, I am using Javascript's geolocation API. Open live link on two tabs of different/same browsers. Try logging in using two different usernames in the same room name. Try messaging each other, the two tabs can now communicate with each other.",
    thumbnail: "./images/ChatAppImage1.png",
    stack: ["html", "css", "node.js", "javascript", "socket.io"],
    images: [
      "/images/ChatAppImage1.png",
      "/images/ChatAppImage2.jpg",
      "/images/ChatAppImage3.jpg",
      "/images/ChatAppImage4.jpg"
    ]
  },
  {
    index: 3,
    title: "Snake Game",
    link: "https://snakegame-9d7e9.firebaseapp.com/",
    description:
      "A fun snake game reminding us of our childhood memories.",
    role: "Developer",
    summary:
      "I was trying to learn React.js for the first time, and there was no better way to learn by making a game, it was a dual between Tic-Tac-Toe or Snake Game. Snake Game had more logical implementation and offered more challenges.",
    thumbnail: "./images/SnakeGame4.png",
    stack: ["html", "css", "React.js", "javascript"],
    images: [
      "/images/SnakeGame4.png",
      "/images/SnakeGame1.jpg",
      "/images/SnakeGame2.jpg",
      "/images/SnakeGame3.jpg"
    ]
  }
];
export default data;
